// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1qDGc","dragIcon":"Choice_dragIcon__1iMLg","left":"Choice_left__3v1fn","input":"Choice_input__3Xuii"};